import React from "react";
import Loader from "../../../component/loader";

const Message = React.memo((props) => {
  return (
    <div className="chat_list d_flex d_flex_align_center mb_15" id={props.id}>
      <div className="chat_side d_flex d_flex_align_center">
        <span className= {props.isModerator ? 'chat_user_img error_ps' : 'chat_user_img'}>
             <img src={props.image ? props.imageUrl + props.image : "/images/image-placeholder.png"} alt="user" />
        </span>
        <div className="chat_user_data">
          <p><strong className={props.isModerator ? 'error' : ''}>{props.sender}:</strong> {props.message} </p>
        </div>
      </div>
      <div className="delete_icon" onClick={() => props.delete()}>
        <span className="pointer">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.41683 4.5V1.75C5.41683 1.50689 5.51341 1.27373 5.68532 1.10182C5.85722 0.929913 6.09038 0.833336 6.3335 0.833336H13.6668C13.9099 0.833336 14.1431 0.929913 14.315 1.10182C14.4869 1.27373 14.5835 1.50689 14.5835 1.75V4.5H19.1668V6.33334H17.3335V18.25C17.3335 18.4931 17.2369 18.7263 17.065 18.8982C16.8931 19.0701 16.6599 19.1667 16.4168 19.1667H3.5835C3.34038 19.1667 3.10722 19.0701 2.93532 18.8982C2.76341 18.7263 2.66683 18.4931 2.66683 18.25V6.33334H0.833496V4.5H5.41683ZM7.25016 2.66667V4.5H12.7502V2.66667H7.25016Z"
              fill="black" />
          </svg>
      </span>
      </div>
      {props.loaderFlag && <Loader />}
    </div>
     
  );
});

Message.propTypes = {};

export default Message;